import React, { useState } from 'react';
import './Tickets.css';

const Tickets = ({ tickets, ticketsLoading, onReload, teams, onUpdateStatus }) => {
  const [open, setOpen] = useState({});

  const toggle = (id) => setOpen((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <div className="sa-card">
      <div className="sa-card-header">
        <h2>Tickets</h2>
        <div className="sa-actions">
          <button className="sa-btn ghost" onClick={onReload} disabled={ticketsLoading}>
            {ticketsLoading ? 'Loading...' : 'Reload'}
          </button>
        </div>
      </div>
      <div className="tickets-table">
        <div className="tickets-head">
          <span>Ticket</span>
          <span>Status</span>
          <span>Updated</span>
        </div>
        {tickets.map((t) => {
          const isOpen = !!open[t.id];
          const updated =
            t.updatedAt?.seconds ? new Date(t.updatedAt.seconds * 1000).toLocaleString() : '-';
          return (
            <div className="tickets-row" key={t.id}>
              <div className="tickets-top">
                <span className="tickets-cell">
                  <button className="sa-link" onClick={() => toggle(t.id)}>
                    {isOpen ? '▼' : '▶'}
                  </button>
                  {t.subject || 'Support Ticket'}
                  <span className="tickets-subtext">{t.ownerUid || ''}</span>
                </span>
                <span className="tickets-cell">
                  <select
                    className="sa-select"
                    value={t.status || 'open'}
                    onChange={(e) => onUpdateStatus(t.id, e.target.value)}
                  >
                    <option value="open">Open</option>
                    <option value="pending">Pending</option>
                    <option value="resolved">Resolved</option>
                  </select>
                </span>
                <span className="tickets-cell">{updated}</span>
              </div>
              {isOpen && (
                <div className="tickets-expanded">
                  <div className="tickets-detail">
                    <p className="tickets-line">
                      <strong>Team:</strong> {t.teamId || '-'}
                    </p>
                    <p className="tickets-line">
                      <strong>Last message:</strong> {t.lastMessage || '-'}
                    </p>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        {tickets.length === 0 && <div className="sa-empty">No tickets found.</div>}
      </div>
    </div>
  );
};

export default Tickets;
